import PicturesIcon from '../../images/pictures.svg?react';

interface PicturesProps {
  onSelect: () => void;
}

export default function Pictures({ onSelect }: PicturesProps) {
  return <PicturesIcon onClick={onSelect} />;
}
